import * as actionTypes from "../actions/types";
import produce from "immer";
import { v4 as uuidv4 } from "uuid";

const initialState = {
  isTermsAndConditions: false,
  isNewTermsAndConditions: false,
  isOpenFindTermsAndConditions: false,
  termsAndConditionList: {},
  offerTermsAndConditionList: {},
  isSelectedExistingTerms: false,
  selectedBank: null,
  selectBankId: null,
  existingTermsList: {},
  isClearAll: false,
  isAddNew: false,
};

let newData = [];
export default produce((draft = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case actionTypes.SET_SELECTED_BANK:
      draft.selectedBank = payload;
      return draft;
    case actionTypes.OPEN_TERMS_AND_CONDITIONS_MODAL:
      draft.isTermsAndConditions = true;
      draft.isAddNew = false;
      return draft;
    case actionTypes.CLOSE_TERMS_AND_CONDITIONS_MODAL:
      draft.isTermsAndConditions = false;
      draft.selectBankId = null;
      draft.isSelectedExistingTerms = false;
      draft.isClearAll = false;
      draft.isAddNew = false;
      return draft;
    case actionTypes.OPEN_CREATE_NEW_TERMS_AND_CONDITIONS_MODAL:
      draft.isNewTermsAndConditions = true;
      draft.termsAndConditionList = action.payload;
      return draft;
    case actionTypes.CLOSE_CREATE_NEW_TERMS_AND_CONDITIONS_MODAL:
      draft.isNewTermsAndConditions = false;
      // draft.termsAndConditionList= {};
      return draft;
    case actionTypes.ADD_NEW_TERMS_INTO_LIST: {
      console.log("ADD_NEW_TERMS_INTO_LIST", {
        ...draft.termsAndConditionList,
      });

      const { bankId, parts } = action.payload;

      // Ensure both lists exist
      draft.existingTermsList = draft.existingTermsList || {};
      draft.termsAndConditionList = draft.termsAndConditionList || {};

      if (draft.existingTermsList[bankId]) {
        // Add to existingTermsList if it exists for this bank
        draft.existingTermsList[bankId] = [
          ...draft.existingTermsList[bankId],
          parts,
        ];
      } else {
        // Otherwise, add to termsAndConditionList
        draft.termsAndConditionList[bankId] = [
          ...(draft.termsAndConditionList[bankId] || []),
          parts,
        ];
      }

      draft.isAddNew = true;
      return draft;
    }

    case actionTypes.EDIT_TERMS_INTO_LIST:
      console.log("EDIT_TERMS_INTO_LIST", action.payload?.bankId);
      const { id, newValue } = action.payload;
      const partList = draft.termsAndConditionList[action.payload?.bankId];
      const existing = draft.existingTermsList
        ? draft.existingTermsList[action.payload?.bankId]
        : {};
      if (partList) {
        const part = partList.find((item) => item.id === id);
        if (part) {
          part.value = newValue;
        }
      }
      if (existing) {
        const part = existing.find((item) => item.id === id);
        if (part) {
          part.value = newValue;
        }
      }
      return draft;
    case actionTypes.DELETE_TERMS_INTO_LIST:
      console.log("DELETE_TERMS_INTO_LIST");
      const { partId } = action.payload;
      const partListFilter =
        draft.termsAndConditionList[action.payload?.bankId];
      const existingTerms = draft.existingTermsList
        ? draft.existingTermsList[action.payload?.bankId]
        : {};
      if (partListFilter) {
        draft.termsAndConditionList[action.payload?.bankId] =
          partListFilter.filter((item) => item.id !== partId);
        if (draft.termsAndConditionList[action.payload?.bankId].length === 0) {
          delete draft.termsAndConditionList[action.payload?.bankId];
        }
      }
      if (existingTerms) {
        draft.existingTermsList[action.payload?.bankId] = existingTerms.filter(
          (item) => item.id !== partId
        );
        if (draft.existingTermsList[action.payload?.bankId].length === 0) {
          delete draft.existingTermsList[action.payload?.bankId];
        }
      }
      return draft;
    case actionTypes.CLEAR_ALL_TERMS_LIST:
      console.log("CLEAR_ALL_TERMS_LIST");
      const selectListFilter =
        draft.termsAndConditionList[action.payload?.bankId];
      const existTerms = draft.existingTermsList
        ? draft.existingTermsList[action.payload?.bankId]
        : {};
      if (selectListFilter) {
        draft.termsAndConditionList[action.payload?.bankId] = [];
        if (draft.termsAndConditionList[action.payload?.bankId].length === 0) {
          delete draft.termsAndConditionList[action.payload?.bankId];
        }
      }
      if (existTerms) {
        draft.existingTermsList[action.payload?.bankId] = [];
        if (draft.existingTermsList[action.payload?.bankId].length === 0) {
          delete draft.existingTermsList[action.payload?.bankId];
        }
      }
      draft.isClearAll = true;
      return draft;

    case actionTypes.SELECT_ALL_TERMS: {
      console.log("SELECT_ALL_TERMS");

      const bankId = action.payload?.bankId;
      const selectedListFilter = draft.termsAndConditionList?.[bankId] || [];
      const existedTerms = draft.existingTermsList?.[bankId] || [];

      selectedListFilter.forEach((item) => {
        item.isActive = item.isActive ? false : true;
      });

      existedTerms.forEach((item) => {
        item.isActive = item.isActive ? false : true;
      });

      return draft;
    }

    case actionTypes.ACTIVE_SELECTED_TERM: {
      console.log("ACTIVE_SELECTED_TERM");

      const bankId = action.payload?.bankId;
      const selectedListFilter = draft.termsAndConditionList?.[bankId] || [];
      const existedTerms = draft.existingTermsList?.[bankId] || [];

      selectedListFilter.forEach((item) => {
        if (item.id === action.payload?.termId) {
          item.isActive = item.isActive ? false : true;
        }
      });

      existedTerms.forEach((item) => {
        if (item.id === action.payload?.termId) {
          item.isActive = item.isActive ? false : true;
        }
      });

      return draft;
    }
    case actionTypes.LOAD_TERMS_AND_CONDITION:
      draft.termsAndConditionList = {};
      console.log("LOAD_TERMS_AND_CONDITION", action.payload);
      draft.termsAndConditionList = action.payload;
      return draft;
    case actionTypes.OPEN_FIND_TERMS_AND_CONDITION:
      draft.isOpenFindTermsAndConditions = true;
      return draft;
    case actionTypes.CLOSE_FIND_TERMS_AND_CONDITION:
      draft.isOpenFindTermsAndConditions = false;
      //draft.termsAndConditionList= {};
      return draft;
    case actionTypes.SELECTED_EXISTING_TERMS:
      draft.existingTermsList = {};
      console.log("SELECTED_EXISTING_TERMS", action);
      const { bankId, terms } = action.payload;

      let extractedTerms = {};
      extractedTerms[bankId] = [];
      if (/<span[^>]*>.*<\/span>/.test(terms)) {
        // ✅ Extract from spans
        const matches = terms.match(/<span[^>]*>(.*?)<\/span>/g) || [];
        extractedTerms[bankId] = matches.map((item) => {
          const text = item.replace(/<[^>]+>/g, "").trim();
          return {
            id: uuidv4(),
            value: text,
            count: 0,
            isActive: true,
          };
        });
      } else if (/<br\s*\/?>/.test(terms)) {
        // ✅ Extract from <br/> separated text
        extractedTerms[bankId] = terms
          .split(/<br\s*\/?>/i)
          .map((t) => t.replace(/<[^>]+>/g, "").trim())
          .filter(Boolean)
          .map((text) => ({
            id: uuidv4(),
            value: text,
            count: 0,
            isActive: true,
          }));
      } else {
        // ✅ Case: plain text (no spans or <br/>)
        extractedTerms = terms;
      }
      draft.existingTermsList = extractedTerms;
      draft.selectBankId = bankId;
      draft.isSelectedExistingTerms = true;
      // draft.termsAndConditionList = {};
      draft.isTermsAndConditions = true;
      console.log("SELECTED_EXISTING_TERMS", { ...draft.existingTermsList });
      return draft;
    case actionTypes.REMOVE__SELECTED_EXISTING_TERMS:
      draft.existingTermsList = {};
      draft.selectBankId = null;
      draft.isSelectedExistingTerms = false;
      draft.isAddNew = false;
      return draft;
    case actionTypes.ADD_EXISING_TERMS_INTO_LIST:
      console.log(
        "ADD_EXISING_TERMS_INTO_LIST",
        { ...draft.termsAndConditionList },
        action
      );
      if (action.payload && action.payload.bankId != null) {
        draft.termsAndConditionList = {
          ...draft.termsAndConditionList,
          [action.payload.bankId]: action.payload.terms,
        };
      } else {
        console.error(
          "Invalid payload for ADD_EXISTING_TERMS_INTO_LIST:",
          action.payload
        );
      }
      return draft;

    case actionTypes.CLEAR_TERMS_AND_CONDITION:
      draft.termsAndConditionList = {};
      draft.existingTermsList = {};
      draft.isAddNew = false;
      return draft;
    case actionTypes.ON_LOAD_OFFERS_TERMS_AND_CONDITION:
      draft.termsAndConditionList = {};
      draft.termsAndConditionList = action.payload;
      return draft;
    case actionTypes.CLEAR_OFFERS_TERMS_AND_CONDITION:
      draft.termsAndConditionList = {};
      draft.isAddNew = false;
      return draft;
    default:
      return draft;
  }
});

// if (Array.isArray(parts[bankId])) {
//   parts[bankId].forEach(part => {
//     console.log("part", part);
//
//   });
// }
